import config from "../config";
import { io } from "socket.io-client";

export const initiateSocket = (user) => {
  console.log("initializing user socket", user);
  // The httpOnly session cookie authenticates the handshake; the API reads it
  // (server.js io.use). No token is readable from JS any more.
  const socket = io(config.socketURL, {
    reconnectionDelayMax: 10000,
    withCredentials: true,
  });
  socket.on("connect", () => console.log(`Client connected: ${socket.id}`));

  socket.on("disconnect", (reason) =>
    console.log(`Client disconnected: ${reason}`)
  );

  socket.on("connect_error", (reason) =>
    console.log(`Client connect_error: ${reason}`)
  );
  return socket;
};